var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useContext } from 'react';
import { UploadContext } from '../contexts/UploadContext';
import { useDropzone } from 'react-dropzone';
var UploadButton = function () {
    var setFileToUpload = useContext(UploadContext).setFileToUpload;
    var onDrop = useCallback(function (acceptedFiles) {
        setFileToUpload(acceptedFiles[0]);
    }, []);
    var _a = useDropzone({ onDrop: onDrop, maxFiles: 1, accept: 'video/*' }), getRootProps = _a.getRootProps, getInputProps = _a.getInputProps, isDragActive = _a.isDragActive;
    return (React.createElement("div", __assign({}, getRootProps(), { className: "flex justify-center mt-10" }),
        React.createElement("div", { className: "w-64 flex flex-col items-center px-4 py-6 bg-black text-blue rounded-lg shadow-lg tracking-wide uppercase border border-blue cursor-pointer hover:bg-blue hover:text-white" },
            React.createElement("svg", { className: "w-8 h-8", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" },
                React.createElement("path", { d: "M16.88 9.1A4 4 0 0 1 16 17H5a5 5 0 0 1-1-9.9V7a3 3 0 0 1 4.52-2.59A4.98 4.98 0 0 1 17 8c0 .38-.04.74-.12 1.1zM11 11h3l-4-4-4 4h3v3h2v-3z" })),
            React.createElement("span", { className: "mt-2 text-base leading-normal" }, "Drag or select a video"),
            React.createElement("input", __assign({}, getInputProps())))));
};
export default UploadButton;
